module.exports = ".btn-group.disabled .btn-primary:hover {\n  cursor: not-allowed;\n  background-color: #007bff;\n  border-color: #0062cc; }\n\n.btn-group.disabled .btn-secondary:hover {\n  cursor: not-allowed;\n  background-color: #868e96;\n  border-color: #6c757d; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/schemas/components/filters.component.scss
// module id = 575
// module chunks = 1